import constants from '@nike/ciclp-react-components/constants';
import { prepareTranslations as videoTranslations } from './video';
import { getPaginationTranslations } from '../helpers';
import { getCommonProps, getTitle } from '../helpers/commonHelpers';
import { mergeGalleryProperties } from '../helpers/carouselHelper';
import {
  getGalleryActions,
  getGalleryPlacements,
  getPaginationActions,
} from '../helpers/analytics';

export const prepareCardData = cardData => ({
  ...getCommonProps(cardData),
  maxResults:
    cardData?.properties?.custom?.maxResults &&
    cardData?.properties?.custom?.maxResults < constants.MAX_GRID_LENGTH
      ? cardData?.properties?.custom?.maxResults
      : constants.MAX_GRID_LENGTH,
  sectionHeadline: getTitle(cardData),
  slides: [],
  speed: cardData?.properties?.speed,
  ...(cardData?.properties?.custom?.maxResults &&
    cardData?.properties?.custom?.maxResults < constants.MAX_GRID_LENGTH && {
      hasOnePage: true,
    }),
  // attributeIds used for OR taxonomy logic, param name from product-feeds API
  attributeIds: cardData?.properties?.valueMap?.editorial_taxonomy?.any,
  // attributeIdsAll used for taxonomy AND logic, param name from product-feeds API
  attributeIdsAll:
    cardData?.properties?.valueMap?.editorial ||
    cardData?.properties?.valueMap?.editorial_taxonomy?.all,
  excludeAttributeIds: cardData?.properties?.valueMap?.editorial_taxonomy?.not,
  featured: cardData?.properties?.custom?.selectedFeature,
});

export const prepareTranslations = (translationsStrings = {}) => ({
  ...videoTranslations(translationsStrings),
  viewAllLabel: translationsStrings.view_all,
  ...getPaginationTranslations(translationsStrings),
});

export { getGalleryUrlIngredients as getUrlIngredients } from '../helpers/carouselHelper/carouselHelper';

export const mergeProperties = ({ cardData, urls, translations, pageType }) => {
  const props = mergeGalleryProperties({
    cardData,
    pageType,
    translations,
    urls,
  });
  if (props?.sectionHeadline?.actions?.[0]?.actionText) {
    props.sectionHeadline.actions[0].actionText = translations.viewAllLabel;
  }
  return props;
};

export const getAnalyticsActions = cardData => [
  ...getGalleryActions(cardData),
  ...getPaginationActions(cardData),
];

export { getGalleryPlacements as getAnalyticsPlacements };

export { getBuyingToolsIngredients } from './common';
